import { render, staticRenderFns } from "./IgM.vue?vue&type=template&id=39242994&scoped=true&"
import script from "./IgM.vue?vue&type=script&lang=js&"
export * from "./IgM.vue?vue&type=script&lang=js&"
import style0 from "./IgM.vue?vue&type=style&index=0&id=39242994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39242994",
  null
  
)

export default component.exports